import { render, staticRenderFns } from "./WarehouseViewExpired.vue?vue&type=template&id=4f62eece&scoped=true"
import script from "./WarehouseViewExpired.vue?vue&type=script&lang=js"
export * from "./WarehouseViewExpired.vue?vue&type=script&lang=js"
import style0 from "./WarehouseViewExpired.vue?vue&type=style&index=0&id=4f62eece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62eece",
  null
  
)

export default component.exports